import React from 'react';
import { faqData } from '../data/mock';
import { HelpCircle } from 'lucide-react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

const FAQ = () => {
  return (
    <section id="faq" className="py-24 bg-gradient-to-b from-bg-card to-bg-page relative overflow-hidden">
      {/* Background decorations */}
      <div className="absolute top-20 left-10 w-72 h-72 bg-brand-primary/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 right-10 w-96 h-96 bg-brand-primary/10 rounded-full blur-3xl"></div>
      
      <div className="container mx-auto px-4 lg:px-8 relative z-10">
        {/* Section Header mejorado */}
        <div className="text-center mb-16">
          <div className="inline-block bg-brand-primary/20 border-2 border-brand-primary rounded-full px-6 py-2 mb-6">
            <span className="text-brand-primary font-black text-sm uppercase tracking-wide flex items-center">
              <HelpCircle className="w-5 h-5 mr-2" />
              Tire Suas Dúvidas
            </span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-black text-white mb-6 uppercase">
            Perguntas Frequentes
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Tire suas dúvidas. Se ainda tiver alguma pergunta, é só chamar no WhatsApp.
          </p>
        </div>

        {/* FAQ Accordion con visual mejorado */}
        <div className="max-w-4xl mx-auto">
          <Accordion type="single" collapsible className="space-y-4">
            {faqData.map((faq, index) => (
              <AccordionItem
                key={faq.id}
                value={`item-${faq.id}`}
                className="relative group"
              >
                {/* Glow effect */}
                <div className="absolute inset-0 bg-gradient-to-r from-brand-primary/10 to-transparent rounded-xl blur-xl opacity-0 group-hover:opacity-100 transition-opacity"></div>
                
                <div className="relative bg-bg-card border-2 border-border-strong rounded-xl px-8 hover:border-brand-primary transition-all">
                  <AccordionTrigger className="text-left hover:no-underline py-6">
                    <div className="flex items-start space-x-4 pr-4">
                      <div className="flex-shrink-0 w-8 h-8 bg-brand-primary rounded-full flex items-center justify-center mt-1">
                        <span className="text-white font-black text-sm">{index + 1}</span>
                      </div>
                      <span className="text-lg font-bold text-white">
                        {faq.question}
                      </span>
                    </div>
                  </AccordionTrigger>
                  <AccordionContent className="pb-6 pl-12">
                    <p className="text-base text-gray-400 leading-relaxed">
                      {faq.answer}
                    </p>
                  </AccordionContent>
                </div>
              </AccordionItem>
            ))}
          </Accordion>
        </div>

        {/* CTA adicional al final */}
        <div className="mt-16 text-center">
          <div className="inline-block bg-gradient-to-r from-bg-card to-black border-2 border-brand-primary/50 rounded-2xl p-8 max-w-2xl">
            <p className="text-xl text-white mb-4">
              Ainda tem dúvidas? <span className="text-brand-primary font-bold">Fale conosco!</span>
            </p>
            <p className="text-gray-400">
              Nossa equipe responde em minutos via WhatsApp
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
